import { render, staticRenderFns } from "./document-classification-body.vue?vue&type=template&id=50a10ae2"
import script from "./document-classification-body.vue?vue&type=script&lang=js"
export * from "./document-classification-body.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports